// src/auth/authConfig.ts
import { PublicClientApplication, Configuration } from '@azure/msal-browser';
import useIsSsoEntra from '@/common/composition/useIsSsoEntra';
import useIsSsoSurf from '@/common/composition/useIsSsoSurf';

// Singleton instance
let msalInstance: PublicClientApplication | null = null;

export function getMsalConfig(): Configuration {
  const authorityHost = import.meta.env.VITE_MSAL_AUTH_AUTHORITY_HOST;
  const tenantDomain = import.meta.env.VITE_MSAL_AUTH_TENANT_DOMAIN;
  const clientId = import.meta.env.VITE_MSAL_AUTH_CLIENT_ID;
  const tenant = import.meta.env.VITE_MSAL_AUTH_TENANT;

  const knownAuthority = `${tenant}.${authorityHost}`;

  // 1. Bepaal hier dynamisch de juiste policy op basis van je app context
  let policy = import.meta.env.VITE_MSAL_AUTH_POLICY_SIGNIN; // Standaard / Algemeen

  if (useIsSsoEntra()) {
    policy = import.meta.env.VITE_SSO_ENTRA_MSAL_AUTH_POLICY_SIGNIN;
  } else if (useIsSsoSurf()) {
    policy = import.meta.env.VITE_SSO_SURF_MSAL_AUTH_POLICY_SIGNIN;
  }

  const authority = `https://${knownAuthority}/${tenant}.${tenantDomain}/${policy}`;

  return {
    auth: {
      clientId,
      authority, // Nu is de authority dynamisch ingesteld voor de hele sessie!
      knownAuthorities: [knownAuthority],
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
  };
}

// 2. Exporteer één functie die altijd dezelfde instance teruggeeft
export function getMsalInstanceShared(): PublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(getMsalConfig());
  }
  return msalInstance;
}
